import React from "react";
import { Card } from "react-bootstrap";

function Header({ totalAmount, totalItems }) {
  return (
    <Card className='text-center mb-3 border-dark border-2'>
      <Card.Body className='p-2'>
        <div className='d-flex justify-content-between align-items-center'>
          <div className='flex-grow-1'>
            <Card.Title>Liste des Courses</Card.Title>
            <Card.Text className="card-text">
              Montant Total: <strong>{totalAmount.toFixed(2)} €</strong>
            </Card.Text>
            <Card.Text>
              Nombre d'Articles: <strong>{totalItems}</strong>
            </Card.Text>
          </div>
          <div className='align-self-start'>
            <p className='aide'>
              <a
                title="Mode d'emploi"
                href='https://charlenry.github.io/portfolio/shopping-cart/doc/mode_demploi.pdf'
                target='_blank'
                rel='noreferrer'>
                <span className='logo_aide'>&#10067;</span>
              </a>
            </p>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

export default Header;
